import React from 'react';
import { getFramework, useIdentity } from '@/framework';
import { IExportPlugin, PluginType } from '@/version-types';
import { ImageCutoutPlugin } from './image-cutout';
import imageCutoutPluginState, { useImageCutoutState } from './states/image-cutout-state';
import ImageCutout from './views/image-cutout';

const ImageCutoutPluginView = React.memo(() => {
    const identity = useIdentity();
    const framework = getFramework(identity);
    const isImageCutout = useImageCutoutState()((state) => state.isImageCutout);
    const externalMethods = useImageCutoutState()((state) => state.externalMethods);
    const externalParams = useImageCutoutState()((state) => state.externalParams);

    if (!isImageCutout) return null;

    return (
        <ImageCutout
            isFree={externalParams.isFree}
            isSilentMode={externalParams.isSilentMode}
            numLeft={externalParams.numLeft}
            leftFreeNum={externalParams.leftFreeNum}
            freeNum={externalParams.freeNum}
            isInternalUserAndNotVipAndNotLeftNum={externalParams.isInternalUserAndNotVipAndNotLeftNum}
            isInternalUserVip={externalParams.isInternalUserVip}
            onCancel={externalMethods.cancelClickHandler}
            onOptimize={externalMethods.optimizeClickHandler}
            onConfirm={externalMethods.confirmClickHandler}
            beforeConfirm={externalMethods.beforeConfirm}
            framework={framework}
            trackFunc={externalParams.trackFunc}
            isIntl={externalParams.isIntl}
        />
    );
});

const exportPlugin: IExportPlugin = {
    type: PluginType.VIEWPORT,
    sort: 3,
    name: 'image-cutout',
    render() {
        return <ImageCutoutPluginView />;
    },
    createInstance({ identity }) {
        return [{ key: 'ImageCutoutPlugin', value: new ImageCutoutPlugin(identity) }];
    },
    createState() {
        return [imageCutoutPluginState];
    },
    destroy({ getInstance }) {
        getInstance<ImageCutoutPlugin>('ImageCutoutPlugin').destroy();
    },
};

export default exportPlugin;
